/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.AddContractConfirmationModal.title',
    defaultMessage: 'Unit HUD Information Must Be Updated',
  },
  confirmationText: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.AddContractConfirmationModal.confirmationText',
    defaultMessage:
      'Saving these changes will not automatically update the HUD Subsidy Type or Contract # assigned to the units with HUD. Any affected units must be updated to ensure certifications use the correct information.',
  },
  warningBanner: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.AddContractConfirmationModal.warningBanner',
    defaultMessage:
      'Go to the Unit(s) > Unit Affordable Setup > Edit, update the applicable HUD Subsidy Type (Contract # will populate based on Subsidy Type chosen), and select Save. Until the units are updated, certifications may continue to use the previously assigned information.',
  },
  cancel: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.AddContractConfirmationModal.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.AddContractConfirmationModal.confirm',
    defaultMessage: 'Confirm',
  },
});

export default messages;
